import React from 'react';
import PriceMatrix from 'pu-react/components/PriceMatrix';
import PropTypes from 'prop-types';
import PriceMatrixCell from './PriceMatrixCellMx';
import PriceMatrixHead from './PriceMatrixHeadMx';
import HowItWorks from '../quote-rules/HowItWorks';

const PriceMX = (props) => {
  const {
    quote,
    quoteStep,
    parameters,
    parametersChanged,
    onPriceSelect,
    showSummary,
  } = props;

  if (!quote || !quote.line_items || !quote.line_items.length) {
    return null;
  }

  const lineItem = quote.line_items.find((li) => li.product_key === 'assembly-mx');
  const { restricted_price } = lineItem

  return (
    <>
      <div className="mx-matrix">
        <div className="d-flex justify-content-between my-2">
          <h2 className="text-uppercase fw-bold">
            Mexico Pcb Assembly
          </h2>
        </div>
        <PriceMatrix
          tableSm
          tableStripe={false}
          lineItem={lineItem}
          supplier={lineItem.product_key}
          parametersChanged={parametersChanged}
          onPriceSelect={onPriceSelect}
          parameters={parameters}
          matrixCell={PriceMatrixCell}
          quoteStep={quoteStep}
          showSummary={showSummary}
          rowSelected={parameters.row_selected}
          matrixHead={PriceMatrixHead}
          groupName="prices"
          restricted_price={restricted_price} />
        <div>
          <ul>
            <li>First Article cost is included (Lead Time = 2 to 3 weeks).</li>
            <li>Production Lead Time starts after First Article is approved.</li>
            <li>To return the leftover parts and SMT Stencil, an additional customs fee (~$500.00) will be applied.</li>
          </ul>
        </div>
        <HowItWorks />
      </div>
    </>
  );
}

PriceMX.propTypes = {
  quote: PropTypes.objectOf(PropTypes.any).isRequired,
  quoteStep: PropTypes.string.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parameters: PropTypes.objectOf(PropTypes.any).isRequired,
  showSummary: PropTypes.bool.isRequired,
}

export default PriceMX;
